<template>
	<v-card style="background-color: rgb(var(--v-theme-contained))" variant="tonal" class="ma-2">
		<v-container v-if="!datatype">
			<v-alert
				type="error"
				:title="symbolsStore.GUILabel('8051f8be-9067-4a43-9efa-33eba2137ca5')"
				:text="symbolsStore.GUILabel('46b4285c-f399-4053-8986-35770be2e2d6')"
			>
			</v-alert>
		</v-container>
		<v-container v-else-if="datatype.id === 'reference'">
			<v-alert type="info" :title="symbolsStore.GUILabel('606a9eeb-b0c5-4abb-a0fd-32ad8843d9a5')">
				<template #text>
					<p>{{ symbolsStore.GUILabel("56a21191-cd05-4a99-9e66-4ac40df2abdd") }}</p>
					<p>{{ symbolsStore.GUILabel("cc653303-fbf1-415f-8691-df7f9f0bc1b4") }}</p>
				</template></v-alert
			>
		</v-container>
		<v-container v-else>
			<DatatypeInput
				:datatype="isArray ? arraytype : datatype"
				:is-array="isArray"
				:attribute-id="instanceAttribute?.id || ''"
				:label="term"
				:autofocus="false"
				:instance-task="undefined"
				:hide-unknown-button="true"
				:style="{
					width: '100%',
					pointerEvents: workspacesStore.isOpenedWorkspaceLocked ? 'none' : undefined,
					opacity: workspacesStore.isOpenedWorkspaceLocked ? 0.6 : undefined,
				}"
				@set="onSet"
			/>
			<!-- <v-container v-if="suggestedValue && suggestedValue !== instanceAttribute?.value && !isArray">
				<v-card
					prepend-icon="mdi-lightbulb-on-10"
					:title="
						'Suggestion: ' +
						(graphStore.descriptor.symbol.term(suggestedValue)
							? graphStore.descriptor.symbol.term(suggestedValue)
							: suggestedValue)
					"
					variant="tonal"
					density="compact"
					color="primary"
					@click="onAccept"
				>
				</v-card>
			</v-container> -->
		</v-container>
	</v-card>
</template>

<script setup lang="ts">
import DatatypeInput from "../DatatypeInput.vue";
import { computed } from "vue";
import { useGraphStore } from "../../../../store/graph";
import { useSymbolsStore } from "../../../../store/symbols";
import { useInstanceWorkspacesStore } from "../../../../store/i-workspace";

const graphStore = useGraphStore();
const symbolsStore = useSymbolsStore();
const workspacesStore = useInstanceWorkspacesStore();

const compProps = defineProps<{
	attributeId: string;
}>();

const instanceAttribute = computed(() => {
	return graphStore.instance.attribute.byId(compProps.attributeId);
});
const conceptAttribute = computed(() => {
	return graphStore.concept.attribute.byId(instanceAttribute.value?.concept || "");
});
const datatype = computed(() => {
	return graphStore.descriptor.datatype.byId(conceptAttribute.value?.datatype || "");
});
const arraytype = computed(() => {
	if (datatype.value?.id !== "array") return;
	return graphStore.descriptor.datatype.byId(conceptAttribute.value?.arraytype || "");
});
const isArray = computed(() => datatype.value?.id === "array");
const term = computed(() => {
	return symbolsStore.term({
		id: conceptAttribute.value?.refersTo || "",
		terminology: conceptAttribute.value?.terminology,
	});
});
function onSet(value: any) {
	if (workspacesStore.isOpenedWorkspaceLocked) return;
	let v = "undefined";
	if (value !== undefined && value !== null && value !== "") v = value;
	graphStore.instance.attribute.update(instanceAttribute.value?.id || "", v);
}
// function onAccept() {
// 	onSet(suggestedValue.value);
// }
</script>
